import React from "react";

export default function TableGrowth() {
  return <div className="box_table_growth"></div>;
}
